var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5107 10C14.5107 10.3536 14.3703 10.6928 14.1202 10.9428C13.8702 11.1929 13.531 11.3333 13.1774 11.3333H5.17741L2.51074 14V3.33333C2.51074 2.97971 2.65122 2.64057 2.90127 2.39052C3.15131 2.14048 3.49045 2 3.84408 2H13.1774C13.531 2 13.8702 2.14048 14.1202 2.39052C14.3703 2.64057 14.5107 2.97971 14.5107 3.33333V10Z",
    stroke: "white",
    strokeWidth: 1.34712,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquare);
export default __webpack_public_path__ + "static/media/message-square.be715b78ffd10e976c31974fbe2805ed.svg";
export { ForwardRef as ReactComponent };